/**
 * BootScreen (S0) — splash shown while App runs the /session boot sequence.
 * Props: { ctx, api, tg, nav, state, setState, params } (see App.jsx SCREEN_PROPS).
 * Rendered INSIDE App's <Screen> wrapper, so it emits body content only.
 *
 * The boot logic itself lives in App.runBoot() (/session → route). This is the
 * purely visual splash the worker sees for the ~1 network hop it takes.
 */
import Spinner from '../components/Spinner.jsx';
import { T } from '../lib/i18n.js';

export default function BootScreen() {
  return (
    <div className="res" style={{ gap: 18 }}>
      <div className="cn-ic" style={{ width: 64, height: 64, fontSize: 34 }}>🕐</div>
      <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: '-.02em' }}>
        {T.app_title}
      </div>
      <Spinner size="md" label={T.loading} />
    </div>
  );
}
